<div class="flex flex-col items-center justify-center gap-10 py-32 mb-32 w-10/12 mx-auto relative">
	<img src="/assets/gifs/not-found.gif" alt="404 not found" class="w-2/3">
	<div class="uppercase text-4xl md:text-6xl w-8/12 lg:w-6/12 absolute text-left flex flex-col top-4/5 -translate-y-1/2 left-1/2 -translate-x-1/2 lg:-translate-x-0">
		<span>{{ 'page.not-found.text-1' | translate }}</span>
		<span class="text-3xl">{{ 'page.not-found.text-2' | translate }}</span>
	</div>
</div>
